import styled, { css } from "styled-components";

const CustomCardWrapper = styled.div`
  display: grid;
  margin: 30px;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
`;

const CustomModalCardWrapper = styled.div`
  display: grid;
  margin: 30px;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
`;

const CustomCard = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  border-radius: 8px;

  &:hover {
    .icons {
      /* display: flex; */
      visibility: visible;
      opacity: 1;
    }
  }

  .inner-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;

    .card-bloqued {
      position: absolute;
      bottom: 10px;
      left: 15px;
      font-weight: bolder;
      background: transparent;
      color: white;
      text-shadow: 2px 2px 4px rgba(0,0,0,0.6);
    }

    .card-checkbox{
      position: absolute;
      z-index: 1;
      height: 40px;
      width: 40px;
      bottom: 8px;
      left: 8px;
      background: white;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.5s ease;

      &>svg{
        visibility: ${({ isSelected }) => isSelected ? "visible" : "hidden"};
      }
    }
  }

  .icons {
    /* display: none; */
    visibility: hidden;
    opacity: 0;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    color: white;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    gap: 70px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    svg{
      transition: color 0.3s;
      color: #00659D;

      &:hover{
      color: #3a87c8;
      }
    }
  }

  .requirements{
    display: ${({ isRequirementsVisible  }) => isRequirementsVisible  ? "flex" : "none"};
    position: absolute;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    .requirements-form{
      max-width: 380px;
      min-width: 350px;
      max-height: 330px;
      border-radius: 8px;
      padding: 10px;
      background: white;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow-y: auto;
    }
  }

  .customCard_text_overlay {
    position: absolute;
    width: 273px;
    height: 300px;
    top: 0;
    right: 0;
    transition: transform 300ms;
    transform: translate3d(0, calc(300px - 3.5rem), 0);
    background: rgb(148, 148, 148);

    .overlay_header{
      color: white;
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: bolder;
      background: rgb(125 125 125);
    }

    .overlay_body{
      height: 243px;
      overflow-y: auto;
    }

    &:hover {
      transform: translate3d(0, 0, 0);
    }
  }

  @media (min-width: 1430px){
    .customCard_text_overlay{
      width: 40%;
    }
  }

  @media only screen and (max-width: 796px) {
    height: 140px;
    width: 320px;

    .inner-content{
      .card-bloqued{
        font-size: 12px;
      }
      .card-checkbox{
        height: 30px;
        width: 30px;
        border-radius: 4px;
      }
    }

    .customCard_text_overlay{
      font-size: 0.785rem;
      transform: translate3d(0,calc(160px - 3rem), 0);
      width: 128px;

      .overlay_header{
        font-size: 0.6rem;
        padding: 8px;
      }

      .overlay_body{
        height: 90px;
      }
    }
  }
`;

const CustomCardImage = styled.img`
  width: 100%;
  height: 150px;
  display: block;
  object-fit: cover;
  object-position: center right;
`;

export {
  CustomCardWrapper,
  CustomModalCardWrapper,
  CustomCard,
  CustomCardImage
};